import { cn } from "djuno-design";
import { Link } from "react-router-dom";

const CustomLink: React.FC<
  React.PropsWithChildren<{
    to: string;
    onClick?: () => void;
    className?: string;
  }>
> = ({ to, onClick, children, className }) => {
  return (
    <Link
      className={cn(
        "cursor-pointer text-sky-500 hover:text-sky-600",
        className
      )}
      to={to}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

export default CustomLink;
